import React from 'react';
import { motion } from 'framer-motion';

interface HeroContentLayoutProps {
  children: React.ReactNode;
}

export function HeroContentLayout({ children }: HeroContentLayoutProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between lg:gap-12 min-h-[400px]">
      {children}
    </div>
  );
}